import React, { Component } from 'react';
import '../css/Experiencia.css';
class Experiencia extends Component {
  render() {
    return (
      <div id="id-experiencia" className="experiencia">
        <div className="panel-experiencia">
          <h1 className="tituloExperiencia">Experiencia en el Mercado</h1>
          <div className="contenedorExperiencia">
            <div className="panelInicio">
              <i id="icono1" className="glyphicon glyphicon-ok"></i>
              <p id="parrafo-Experiencia1" className="parrafo-Experiencia">Industrias del Cacao <strong className="escoder">y Agregados</strong></p>
            </div>
            <div className="panelSecundario">
              <i className="glyphicon glyphicon-ok"></i>
              <p id="parrafo-Experiencia2" className="parrafo-Experiencia">Industrias mecanicas <strong className="escoder">y Industrias Agroquímicas</strong></p>
            </div>
            <div className="panelSecundario">
              <i class="glyphicon glyphicon-ok"></i>
              <p id="parrafo-Experiencia3" className="parrafo-Experiencia">Industrias del snack <strong className="escoder">y Costos Industriales</strong></p>
            </div>
            <div className="panelSecundario">
              <i class="glyphicon glyphicon-ok"></i>
              <p id="parrafo-Experiencia4" className="parrafo-Experiencia">Turismo receptivo <strong className="escoder">y Empresas Comerciales</strong></p>
            </div>
            <div className="panelSecundario">
              <i class="glyphicon glyphicon-ok"></i>
              <p id="parrafo-Experiencia5" className="parrafo-Experiencia">Agencias de carga <strong className="escoder">y Agencias de Aduana</strong></p>
            </div>
            <div className="panelSecundario">
              <i class="glyphicon glyphicon-ok"></i>
              <p id="parrafo-Experiencia6" className="parrafo-Experiencia">Librerías <strong className="escoder">y Industrias Textiles</strong></p>
            </div>
            <div className="panelSecundario">
              <i class="glyphicon glyphicon-ok"></i>
              <p id="parrafo-Experiencia7" className="parrafo-Experiencia"><strong className="Primaryescoder">Otros</strong></p>
            </div>
            <a className="btn btn-primary" id='button' href="#descripcionfondosistema">
              <p className="parrafo-buttonExperiencia">Listo</p>
            </a>
          </div>
        </div>
      </div>
    );
  }



}
export default Experiencia;


// WEBPACK FOOTER //
// ./src/components/Experiencia.jsx